import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 12/14;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 12 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.655 3.728l.797-.797c.27-.27.709-.27.978 0l.49.49a.69.69 0 0 1 0 .979l-.796.797a5.54 5.54 0 1 1-5.276-2.384v-.735h-.69a.695.695 0 0 1-.695-.692V.692c0-.382.312-.692.695-.692h2.765c.384 0 .695.311.695.692v.694a.694.694 0 0 1-.695.692h-.69v.735c.89.111 1.715.433 2.422.915zM5.54 12.466a4.155 4.155 0 1 0 0-8.31 4.155 4.155 0 0 0 0 8.31zm-.693-6.922a.692.692 0 1 1 1.385 0v2.764a.692.692 0 1 1-1.385 0V5.544z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconStopwatch extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
